export const icons = {
  apollo: { type: 'svg', name: 'Apollo GraphQL', icon: 'apollo.svg', url: 'https://www.apollographql.com/' },
  argocd: { type: 'svg', name: 'ArgoCD', icon: 'argocd.svg', url: 'https://argo-cd.readthedocs.io/' },
  auth0: { type: 'svg', name: 'Auth0', icon: 'auth0.svg', url: 'https://auth0.com' },
  bitbucket: {
    type: 'svg',
    name: 'BitBucket',
    icon: 'bitbucket.svg',
    url: 'https://bitbucket.org/',
  },
  c: { type: 'image', name: 'C', icon: 'c', url: 'https://en.wikipedia.org/wiki/C_(programming_language)' },
  csharp: { type: 'svg', name: 'C#', icon: 'csharp.svg', url: 'https://dotnet.microsoft.com/en-us/languages/csharp' },
  cpp: { type: 'svg', name: 'C++', icon: 'cpp.svg', url: 'https://en.wikipedia.org/wiki/C%2B%2B' },
  css: { type: 'svg', name: 'CSS3', icon: 'css3.svg', url: 'https://en.wikipedia.org/wiki/CSS' },
  devops: { type: 'svg', name: 'DevOps', icon: 'devops.svg', url: 'https://en.wikipedia.org/wiki/DevOps' },
  docker: { type: 'svg', name: 'Docker', icon: 'docker.svg', url: 'https://www.docker.com/' },
  eck: {
    type: 'svg',
    name: 'ECK',
    icon: 'elastic.svg',
    url: 'https://www.elastic.co/guide/en/cloud-on-k8s/current/k8s-quickstart.html',
  },
  elasticsearch: {
    type: 'svg',
    name: 'ElasticSearch',
    icon: 'elasticsearch.svg',
    url: 'https://www.elastic.co/downloads/elasticsearch',
  },
  kibana: {
    type: 'svg',
    name: 'Kibana',
    icon: 'kibana.svg',
    url: 'https://www.elastic.co/kibana',
  },
  ember: { type: 'svg', name: 'EmberJS', icon: 'ember.svg', url: 'https://emberjs.com/' },
  es6: { type: 'svg', name: 'ES6', icon: 'es6.svg', url: 'https://en.wikipedia.org/wiki/ECMAScript' },
  flow: { type: 'svg', name: 'Flow', icon: 'flow.svg', url: 'https://flow.org/' },
  harbor: { type: 'svg', name: 'Harbor', icon: 'harbor.svg', url: 'https://goharbor.io/' },
  html: {
    type: 'svg',
    name: 'HTML5',
    icon: 'html5.svg',
    url: 'https://de.wikipedia.org/wiki/Hypertext_Markup_Language',
  },
  java: { type: 'svg', name: 'Java', icon: 'java.svg', url: 'https://www.java.com/de/' },
  javascript: {
    type: 'svg',
    name: 'Javascript',
    icon: 'javascript.svg',
    url: 'https://en.wikipedia.org/wiki/JavaScript',
  },
  jenkins: { type: 'svg', name: 'Jenkins', icon: 'jenkins.svg', url: 'https://www.jenkins.io/' },
  jira: { type: 'svg', name: 'Jira', icon: 'jira.svg', url: 'https://www.atlassian.com/software/jira' },
  kubernetes: { type: 'svg', name: 'Kubernets', icon: 'kubernetes.svg', url: 'https://kubernetes.io/' },
  mui: { type: 'svg', name: 'MUI', icon: 'material-ui.svg', url: 'https://mui.com/' },
  nestjs: { type: 'svg', name: 'NestJS', icon: 'nestjs.svg', url: 'https://nestjs.com/' },
  nx: { type: 'svg', name: 'NX', icon: 'nx.svg', url: 'https://nx.dev/' },
  prisma: { type: 'svg', name: 'Prisma.io', icon: 'prisma.svg', url: 'https://www.prisma.io/' },
  redis: { type: 'svg', name: 'Redis', icon: 'redis.svg', url: 'https://redis.io/' },
  'redis-cluster': { type: 'svg', name: 'Redis Cluster', icon: 'redis.svg', url: 'https://redis.io/' },
  rails: { type: 'svg', name: 'Ruby on Rails', icon: 'rails.svg', url: 'https://rubyonrails.org/' },
  ruby: { type: 'svg', name: 'Ruby', icon: 'ruby.svg', url: 'https://www.ruby-lang.org/en/' },
  scss: { type: 'svg', name: 'SCSS', icon: 'scss.svg', url: 'https://sass-lang.com/' },
  svn: { type: 'svg', name: 'Subversion', icon: 'subversion.svg', url: 'https://subversion.apache.org/' },
  tailwind: { type: 'svg', name: 'Tailwind', icon: 'tailwind-css.svg', url: 'https://tailwindcss.com/' },
  temporal: { type: 'image', name: 'Temporal.io', icon: 'temporal', url: 'https://temporal.io/' },
  typescript: { type: 'svg', name: 'Typescript', icon: 'typescript.svg', url: 'https://www.typescriptlang.org/' },
  vscode: { type: 'svg', name: 'VS Code', icon: 'vs-code.svg', url: 'https://code.visualstudio.com/' },
  node: { type: 'svg', name: 'Node.js', icon: 'nodejs.svg', url: 'https://nodejs.org' },
  solr: { type: 'svg', name: 'Solr', icon: 'solr.svg', url: 'https://solr.apache.org/' },
  rancher: { type: 'svg', name: 'Rancher', icon: 'rancher.svg', url: 'https://www.rancher.com/' },
  postgres: { type: 'svg', name: 'Postgres', icon: 'postgresql.svg', url: 'https://www.postgresql.org/' },
  'postgres-ha': { type: 'svg', name: 'Postgres HA', icon: 'postgresql.svg', url: 'https://www.postgresql.org/' },
  keycloak: { type: 'image', name: 'Keycloak', icon: 'keycloak', url: 'https://www.keycloak.org/' },
  bullmq: { type: 'image', name: 'BullMQ', icon: 'bullmq', url: 'https://bullmq.io/' },
  php: { type: 'svg', name: 'PHP', icon: 'php.svg', url: 'https://www.php.net/' },
  helm: { type: 'svg', name: 'Helm', icon: 'helm.svg', url: 'https://helm.sh/' },
  react: { type: 'svg', name: 'React', icon: 'react.svg', url: 'https://react.dev/' },
  'objective-c': {
    type: 'svg',
    name: 'Objective-C',
    icon: 'objective-c.svg',
    url: 'https://en.wikipedia.org/wiki/Objective-C',
  },
  mysql: { type: 'svg', name: 'Mysql', icon: 'mysql.svg', url: 'https://www.mysql.com/' },
  git: { type: 'svg', name: 'Git', icon: 'git.svg', url: 'https://git-scm.com/' },
  kustomize: { type: 'svg', name: 'Kustomize', icon: 'kustomize.svg', url: 'https://kustomize.io/' },
  'oauth-proxy': {
    type: 'svg',
    name: 'OAuth2 Proxy',
    icon: 'oauth2-proxy.svg',
    url: 'https://oauth2-proxy.github.io/oauth2-proxy/',
  },
  'cert-manager': { type: 'image', name: 'Cert Manager', icon: 'cert-manager', url: 'https://cert-manager.io/' },
  'sealed-secrets': {
    type: 'image',
    name: 'Sealed Secrets',
    icon: 'sealed-secrets',
    url: 'https://github.com/bitnami-labs/sealed-secrets',
  },
  nextjs: { type: 'svg', name: 'Next.JS', icon: 'nextjs.svg', url: 'https://nextjs.org/' },
  github: { type: 'svg', name: 'Github', icon: 'github.svg', url: 'https://github.com/' },
  'github-action-runner': {
    type: 'svg',
    name: 'Github Action Runner',
    icon: 'githubactions.svg',
    url: 'https://docs.github.com/en/actions/using-github-hosted-runners/about-github-hosted-runners',
  },
  maven: { type: 'svg', name: 'Maven', icon: 'maven.svg', url: 'https://maven.apache.org/' },
  intellij: { type: 'svg', name: 'IntelliJ IDEA', icon: 'intellij-idea.svg', url: 'https://www.jetbrains.com/idea/' },
  confluence: {
    type: 'svg',
    name: 'Confluence',
    icon: 'confluence.svg',
    url: 'https://www.atlassian.com/software/confluence',
  },
  'github-actions': {
    type: 'svg',
    name: 'Github Actions',
    icon: 'githubactions.svg',
    url: 'https://docs.github.com/en/actions',
  },
  rabbitmq: { type: 'svg', name: 'RabbitMQ', icon: 'rabbitmq.svg', url: 'https://www.rabbitmq.com/' },
  terraform: { type: 'svg', name: 'TerraForm', icon: 'terraform.svg', url: 'https://www.terraform.io/' },
  heroku: { type: 'svg', name: 'Heroku', icon: 'heroku.svg', url: 'https://www.heroku.com/' },
  aws: {
    type: 'svg',
    name: 'AWS',
    icon: 'aws.svg',
    url: 'https://aws.amazon.com/',
  },
  gcp: {
    type: 'svg',
    name: 'Google Cloud Platform',
    icon: 'google-cloud.svg',
    url: 'https://cloud.google.com',
  },
  azure: { type: 'svg', name: 'Azure', icon: 'azure.svg', url: 'https://azure.microsoft.com/' },
  storybook: { type: 'svg', name: 'Storybook', icon: 'storybook.svg', url: 'https://storybook.js.org/' },
  jest: { type: 'svg', name: 'Jest', icon: 'jest.svg', url: 'https://jestjs.io/' },
  webpack: { type: 'svg', name: 'Webpack', icon: 'webpack.svg', url: 'https://webpack.js.org/' },
  vitest: { type: 'svg', name: 'Vitest', icon: 'vitest.svg', url: 'https://vitest.dev/' },
  swc: { type: 'svg', name: 'SWC', icon: 'swc.svg', url: 'https://swc.rs/' },
  wordpress: { type: 'svg', name: 'Wordpress', icon: 'wordpress.svg', url: 'https://wordpress.org/' },
  magnolia: { type: 'image', name: 'Magnolia', icon: 'magnolia', url: 'https://www.magnolia-cms.com/' },
  aem: {
    type: 'svg',
    name: 'Adobe Experience Manager',
    icon: 'adobe-experience-manager.svg',
    url: 'https://business.adobe.com/uk/products/experience-manager/adobe-experience-manager.html',
  },
  typeorm: {
    type: 'svg',
    name: 'TypeORM',
    icon: 'typeorm.svg',
    url: 'https://typeorm.io/',
  },
  playwright: {
    type: 'svg',
    name: 'Playwright',
    icon: 'playwright.svg',
    url: 'https://playwright.dev/',
  },
  selenium: {
    type: 'svg',
    name: 'Selenium',
    icon: 'selenium.svg',
    url: 'https://www.selenium.dev/',
  },
  grafana: {
    type: 'svg',
    name: 'Grafana',
    icon: 'grafana.svg',
    url: 'https://grafana.com/',
  },
  prometheus: {
    type: 'svg',
    name: 'Prometheus',
    icon: 'prometheus.svg',
    url: 'https://prometheus.io/',
  },
  'grafana-loki': {
    type: 'svg',
    name: 'Grafana Loki',
    icon: 'grafana-loki.svg',
    url: 'https://grafana.com/oss/loki/',
  },
  'grafana-tempo': {
    type: 'svg',
    name: 'Grafana Tempo',
    icon: 'grafana-tempo.svg',
    url: 'https://grafana.com/oss/tempo/',
  },
  trello: {
    type: 'svg',
    name: 'Trello',
    icon: 'trello.svg',
    url: 'https://trello.com/',
  },
  circleci: {
    type: 'svg',
    name: 'CircleCI',
    icon: 'circleci.svg',
    url: 'https://circleci.com/',
  },
  cloudflare: {
    type: 'svg',
    name: 'Cloudflare',
    icon: 'cloudflare.svg',
    url: 'https://www.cloudflare.com/',
  },
  express: {
    type: 'svg',
    name: 'Express.js',
    icon: 'express.svg',
    url: 'https://expressjs.com/',
  },
  jelastic: {
    type: 'svg',
    name: 'Jelastic',
    icon: 'jelastic.svg',
    url: 'https://www.virtuozzo.com/application-platform/',
  },
  phrase: {
    type: 'svg',
    name: 'Phrase',
    icon: 'phrase.svg',
    url: 'https://phrase.com/',
  },
  puppeteer: {
    type: 'svg',
    name: 'Puppeteer',
    icon: 'puppeteer.svg',
    url: 'https://pptr.dev/',
  },
  sequelize: {
    type: 'svg',
    name: 'Sequelize',
    icon: 'sequelize.svg',
    url: 'https://sequelize.org/',
  },
  python: {
    type: 'svg',
    name: 'Python',
    icon: 'python.svg',
    url: 'https://www.python.org/',
  },
  flow_swiss: {
    type: 'svg',
    name: 'Flow',
    icon: 'flow_swiss.svg',
    url: 'https://www.flow.swiss/',
  },
  oidc: {
    type: 'svg',
    name: 'OIDC',
    icon: 'oidc.svg',
    url: 'https://openid.net/connect/',
  },
} as const satisfies Record<string, { type: 'svg' | 'image'; name: string; icon: string; url: `https://${string}` }>;
